// «Bloques reales» / «Bloques por defecto» en la repetición, el análisis y al ver
// partidas en vivo. La elección se guarda en localStorage (el tablero de Unity la
// lee también) y se manda a Unity con el evento REPLAY_BLOCK_VISUALS.

export const REPLAY_BLOCK_VISUALS_STORAGE_KEY = "xima_replay_block_visuals_v1";
export const REPLAY_BLOCK_VISUALS_EVENT = "REPLAY_BLOCK_VISUALS";

const DEFAULT_DESIGN_IDS = new Set(["", "default", "default_star"]);

export const normalizeReplayBlockVisualsMode = (value) =>
  String(value || "").trim().toLowerCase() === "default" ? "default" : "real";

export const readReplayBlockVisualsMode = () => {
  try {
    return normalizeReplayBlockVisualsMode(
      window.localStorage.getItem(REPLAY_BLOCK_VISUALS_STORAGE_KEY)
    );
  } catch (_error) {
    return "real";
  }
};

export const writeReplayBlockVisualsMode = (mode) => {
  const normalized = normalizeReplayBlockVisualsMode(mode);
  try {
    window.localStorage.setItem(REPLAY_BLOCK_VISUALS_STORAGE_KEY, normalized);
  } catch (_error) {
    // Sin almacenamiento: vale solo para esta vista.
  }
  return normalized;
};

const normalizeDesignId = (value) => String(value || "").trim().toLowerCase();

// Mismo orden de jugadores que el servidor manda a Unity en la repetición.
export const resolveReplayUsers = (participants) =>
  (Array.isArray(participants) ? participants : [])
    .map((participant) => String(participant?.userId || participant?.displayName || "").trim())
    .filter(Boolean);

const profileForUser = (profiles, userId) => {
  if (!profiles || typeof profiles !== "object") return {};
  const key = String(userId || "").trim().toLowerCase();
  return profiles[key] || profiles[userId] || {};
};

// ¿La partida guardó algún diseño de bloque distinto del de por defecto?
export const replayHasRealBlockDesigns = (participants, profiles) =>
  resolveReplayUsers(participants).some((userId) => {
    const profile = profileForUser(profiles, userId);
    return (
      !DEFAULT_DESIGN_IDS.has(normalizeDesignId(profile.specialBlockId)) ||
      !DEFAULT_DESIGN_IDS.has(normalizeDesignId(profile.commonBlockThemeId))
    );
  });

export const buildReplayBlockVisualsPayload = (mode, participants, profiles) => {
  const players = resolveReplayUsers(participants).map((userId, playerIndex) => {
    const profile = profileForUser(profiles, userId);
    return {
      playerIndex,
      userId,
      specialSkin: normalizeDesignId(profile.specialBlockId),
      commonSkin: normalizeDesignId(profile.commonBlockThemeId),
      blockMaterialTexture: "",
      blockAnimation: "",
      blockColor: "",
    };
  });
  return JSON.stringify({ mode: normalizeReplayBlockVisualsMode(mode), players });
};
